 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01COVER from '@/components/001Cover'
 import A02HALF_TITLE from '@/components/002Half_Title'
 import A03TITLE_PAGE from '@/components/003Title_Page'
 import A04COPYRIGHT from '@/components/004Copyright'
 import A05DEDICATION from '@/components/005Dedication'
 import A06CONTENTS from '@/components/006Contents'
 import A07LIST_OF_ILLUSTRATIONS from '@/components/007List_of_Illustrations'
 import A08PLATES from '@/components/008Plates'
 import A09PROLOGUE_DID_SOMEONE_SAY_X2018CLIMATE_CHANGEX0027 from '@/components/009Prologue_Did_Someone_Say_x2018Climate_Changex0027'
 import A10INTRODUCTION_THE_X2018LITTLE_ICE_AGEX2019_AND_THE_X2018GENERAL_CRISISX2019 from '@/components/010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019'
 import A11PART_I_THE_PLACENTA_OF_THE_CRISIS from '@/components/011PART_I_THE_PLACENTA_OF_THE_CRISIS'
 import A121_THE_LITTLE_ICE_AGE from '@/components/0121_The_Little_Ice_Age'
 import A132_THE_X2018GENERAL_CRISISX2019 from '@/components/0132_The_x2018General_Crisisx2019'
 import A143_X2018HUNGER_IS_THE_GREATEST_ENEMYX2019_THE_HEART_OF_THE_CRISIS from '@/components/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis'
 import A154_X2018A_THIRD_OF_THE_WORLD_HAS_DIEDX2019_SURVIVING_IN_THE_SEVENTEENTH_CENTURY from '@/components/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century'
 import A16PART_II_ENDURING_THE_CRISIS from '@/components/016PART_II_ENDURING_THE_CRISIS'
 import A175_THE_X2018GREAT_ENTERPRISEX2019_IN_CHINA_1618X201384 from '@/components/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384'
 import A186_X2018THE_GREAT_SHAKINGX2019_RUSSIA_AND_THE_POLISHLITHUANIAN_COMMONWEALTH_1618X201386 from '@/components/0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386'
 import A197_THE_X2018OTTOMAN_TRAGEDYX2019_1618X201383 from '@/components/0197_The_x2018Ottoman_tragedyx2019_1618x201383'
 import A208_THE_X2018LAMENTATIONS_OF_GERMANYX2019_AND_ITS_NEIGHBOURS_1618X201388 from '@/components/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388'
 import A219_THE_AGONY_OF_THE_IBERIAN_PENINSULA_1618X201389 from '@/components/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389'
 import A2210_FRANCE_IN_CRISIS_1618X201388 from '@/components/02210_France_in_Crisis_1618x201388'
 import A2311_THE_STUART_MONARCHY_THE_PATH_TO_CIVIL_WAR_1603X201342 from '@/components/02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342'
 import A2412_BRITAIN_AND_IRELAND_FROM_CIVIL_WAR_TO_REVOLUTION_1642X201389 from '@/components/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389'
 import A25PART_III_SURVIVING_THE_CRISIS from '@/components/025PART_III_SURVIVING_THE_CRISIS'
 import A2613_THE_MUGHALS_AND_THEIR_NEIGHBOURS from '@/components/02613_The_Mughals_and_their_Neighbours'
 import A2714_RED_FLAG_OVER_ITALY from '@/components/02714_Red_Flag_over_Italy'
 import A2815_THE_X2018DARK_CONTINENTSX2019_THE_AMERICAS_AFRICA_AND_AUSTRALIA from '@/components/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia'
 import A2916_GETTING_IT_RIGHT_EARLY_TOKUGAWA_JAPAN from '@/components/02916_Getting_it_Right_Early_Tokugawa_Japan'
 import A30PART_IV_CONFRONTING_THE_CRISIS from '@/components/030PART_IV_CONFRONTING_THE_CRISIS'
 import A3117_X2018THOSE_WHO_HAVE_NO_MEANS_OF_SUPPORTX2019_THE_PARAMETERS_OF_POPULAR_RESISTANCE from '@/components/03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance'
 import A3218_X2018PEOPLE_WHO_HOPE_ONLY_FOR_A_CHANGEX2019_ARISTOCRATS_INTELLECTUALS_CLERICS_AND_X2018DIRTY_PEOPLE_OF_NO_NAMEX2019 from '@/components/03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019'
 import A3319_X2018PEOPLE_OF_HETERODOX_BELIEFS_X2026_WHO_WILL_JOIN_UP_WITH_ANYONE_WHO_CALLS_THEMX2019_DISSEMINATING_REVOLUTION from '@/components/03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution'
 import A34PART_V_BEYOND_THE_CRISIS from '@/components/034PART_V_BEYOND_THE_CRISIS'
 import A3520_ESCAPING_THE_CRISIS from '@/components/03520_Escaping_the_Crisis'
 import A3621_FROM_WARFARE_STATE_TO_WELFARE_STATE from '@/components/03621_From_Warfare_State_to_Welfare_State'
 import A3722_THE_GREAT_DIVERGENCE from '@/components/03722_The_Great_Divergence'
 import A38CONCLUSION_THE_CRISIS_ANATOMIZED from '@/components/038Conclusion_The_Crisis_Anatomized'
 import A39EPILOGUE_X2018ITX0027S_THE_CLIMATE_STUPIDX2019 from '@/components/039Epilogue_x2018Itx0027s_the_climate_stupidx2019'
 import A40CHRONOLOGY from '@/components/040Chronology'
 import A41ACKNOWLEDGEMENTS from '@/components/041Acknowledgements'
 import A42NOTE_ON_CONVENTIONS from '@/components/042Note_on_Conventions'
 import A43NOTE_ON_SOURCES_AND_BIBLIOGRAPHY from '@/components/043Note_on_Sources_and_Bibliography'
 import A44ABBREVIATIONS_USED_IN_THE_BIBLIOGRAPHY_AND_NOTES from '@/components/044Abbreviations_Used_in_the_Bibliography_and_Notes'
 import A45NOTES from '@/components/045Notes'
 import A46BIBLIOGRAPHY from '@/components/046Bibliography'
 import A47INDEX from '@/components/047Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/001Cover",
 			"name" : "001Cover",
 			"component" : A01COVER
 		},
 		{
 			"path" : "/002Half_Title",
 			"name" : "002Half_Title",
 			"component" : A02HALF_TITLE
 		},
 		{
 			"path" : "/003Title_Page",
 			"name" : "003Title_Page",
 			"component" : A03TITLE_PAGE
 		},
 		{
 			"path" : "/004Copyright",
 			"name" : "004Copyright",
 			"component" : A04COPYRIGHT
 		},
 		{
 			"path" : "/005Dedication",
 			"name" : "005Dedication",
 			"component" : A05DEDICATION
 		},
 		{
 			"path" : "/006Contents",
 			"name" : "006Contents",
 			"component" : A06CONTENTS
 		},
 		{
 			"path" : "/007List_of_Illustrations",
 			"name" : "007List_of_Illustrations",
 			"component" : A07LIST_OF_ILLUSTRATIONS
 		},
 		{
 			"path" : "/008Plates",
 			"name" : "008Plates",
 			"component" : A08PLATES
 		},
 		{
 			"path" : "/009Prologue_Did_Someone_Say_x2018Climate_Changex0027",
 			"name" : "009Prologue_Did_Someone_Say_x2018Climate_Changex0027",
 			"component" : A09PROLOGUE_DID_SOMEONE_SAY_X2018CLIMATE_CHANGEX0027
 		},
 		{
 			"path" : "/010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019",
 			"name" : "010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019",
 			"component" : A10INTRODUCTION_THE_X2018LITTLE_ICE_AGEX2019_AND_THE_X2018GENERAL_CRISISX2019
 		},
 		{
 			"path" : "/011PART_I_THE_PLACENTA_OF_THE_CRISIS",
 			"name" : "011PART_I_THE_PLACENTA_OF_THE_CRISIS",
 			"component" : A11PART_I_THE_PLACENTA_OF_THE_CRISIS
 		},
 		{
 			"path" : "/0121_The_Little_Ice_Age",
 			"name" : "0121_The_Little_Ice_Age",
 			"component" : A121_THE_LITTLE_ICE_AGE
 		},
 		{
 			"path" : "/0132_The_x2018General_Crisisx2019",
 			"name" : "0132_The_x2018General_Crisisx2019",
 			"component" : A132_THE_X2018GENERAL_CRISISX2019
 		},
 		{
 			"path" : "/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis",
 			"name" : "0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis",
 			"component" : A143_X2018HUNGER_IS_THE_GREATEST_ENEMYX2019_THE_HEART_OF_THE_CRISIS
 		},
 		{
 			"path" : "/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century",
 			"name" : "0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century",
 			"component" : A154_X2018A_THIRD_OF_THE_WORLD_HAS_DIEDX2019_SURVIVING_IN_THE_SEVENTEENTH_CENTURY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js